import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';

const FAQ = () => {
  const items = [
    {
      question: "¿Trabajan con soluciones estándar o a medida?",
      answer:
        "Desarrollamos soluciones a medida. Cada sistema se adapta a la forma de trabajo del cliente. En algunos casos reutilizamos componentes para optimizar tiempos, pero la lógica siempre responde a la necesidad real.",
    },
    {
      question: "¿Necesito equipos especiales para usar el sistema?",
      answer:
        "No. Las soluciones funcionan desde el navegador y pueden utilizarse en PC, notebook, tablet o celular. Si el proyecto lo requiere, también desarrollamos aplicaciones móviles específicas.",
    },
    {
      question: "¿Se puede acceder desde cualquier lugar?",
      answer:
        "Sí. Los sistemas están diseñados para ser accesibles desde cualquier dispositivo con conexión a internet, con información actualizada en tiempo real y acceso seguro mediante usuario y contraseña.",
    },
    {
      question: "¿Se puede integrar con otras herramientas?",
      answer:
        "Sí. Es posible conectar el sistema con otras plataformas, servicios o formularios para automatizar procesos y evitar tareas duplicadas.",
    },
    {
      question: "¿Incluyen soporte después de la entrega?",
      answer:
        "Sí. Acompañamos la implementación y realizamos los ajustes necesarios para asegurar que el sistema funcione correctamente en el uso diario.",
    },
    {
      question: "¿Cómo se define el costo?",
      answer:
        "El costo depende del alcance y la complejidad del proyecto. Primero analizamos la necesidad y, en base a eso, definimos una propuesta clara y acorde a lo que realmente se necesita.",
    },
  ];

  return (
    <section id="faq" className="py-24 bg-slate-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14">
          <span className="inline-flex px-4 py-2 rounded-full bg-blue-50 text-blue-700 text-sm font-semibold mb-4">
            Preguntas frecuentes
          </span>

          <h2 className="text-4xl sm:text-5xl font-bold text-slate-900 mb-4">
            Resolvemos las dudas más comunes
          </h2>

          <p className="text-xl text-slate-600">
            Estas son algunas de las preguntas habituales antes de comenzar a trabajar juntos.
          </p>
        </div>

        <div className="bg-white rounded-3xl border border-slate-200 shadow-sm px-6 sm:px-8 py-4">
          <Accordion type="single" collapsible className="w-full">
            {items.map((item, index) => (
              <AccordionItem key={item.question} value={`item-${index}`}>
                <AccordionTrigger className="text-left text-lg font-semibold text-slate-900">
                  {item.question}
                </AccordionTrigger>

                <AccordionContent className="text-slate-600 leading-relaxed text-base">
                  {item.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default FAQ;